import { startPresentation, updateCache } from '@services';
import { ConnectionData } from 'types';

export async function pingConnection(data: ConnectionData) {
    // To-do: validate incoming data for required keys
    await startPresentation(data);

    const { repLeadId, repConnected } = data;

    // Won't be necessary when typing is improved
    if (!repLeadId || repConnected === undefined) {
        console.warn(`Some required cache values are missing. LeadId: ${repLeadId}, repConnected: ${repConnected}`);
    } else {
        const cacheSpecificData = { repLeadId, repConnected };

        await updateCache(repLeadId, cacheSpecificData);
    }
}
